/**
 * Map-only camera overrides for hotel search. Keyed by the place ID the user actually searches (e.g. Sydney).
 * The search itself still runs against that place, so the list view and the map pins include every offer in the wider area
 */

export const outBoundOverwrite: Record<string, App.OfferListBounds> = {
  'le_678c61ac5b4f91ca86e112fc50e63766': { // Sydney -> Sydney Central Business District (le_3b1b1222c9e8e9afa9d1ee10d6e80fc0, r=1.6km)
    southwest: { lat: -33.882594, lng: 151.193100 },
    northeast: { lat: -33.853193, lng: 151.228509 },
  },
  'le_15fa44474c92da27cf2125373356db4c': { // Melbourne -> Melbourne Central Business District (le_32530ba0f5faff63a2f1ccb9c1bc90fc, r=3.5km)
    southwest: { lat: -37.858625, lng: 144.929404 },
    northeast: { lat: -37.796348, lng: 145.008249 },
  },
  'le_7c27cf9f8fe09724bb754e474610eb0e': { // Perth -> Perth Central Business District (le_187c3fb00828eae7f44b0e0b2b6f1877, r=1.4km)
    southwest: { lat: -31.970371, lng: 115.841867 },
    northeast: { lat: -31.944669, lng: 115.872160 },
  },
  'le_b96d145f6c31e35755f4a6841574ba37': { // Brisbane -> Brisbane Central Business District (le_7dd5d0e1dbd8aed668ed1d6a2e402846, r=1.5km)
    southwest: { lat: -27.482514, lng: 153.008711 },
    northeast: { lat: -27.455489, lng: 153.039170 },
  },
  'le_f4c2c73d7fe5eb38fd83d32a61604247': { // Adelaide -> Adelaide Central Business District (le_17f97623431f2025902d7f0fef1b70b1, r=1.9km)
    southwest: { lat: -34.945441, lng: 138.582042 },
    northeast: { lat: -34.912042, lng: 138.622778 },
  },
  'le_b573c52d599a979ba8c16e9789bb8014': { // Hobart -> Hobart Central Business District (le_9c9c4718960bd8d37d674c923df91eeb, r=1.9km)
    southwest: { lat: -42.901422, lng: 147.302179 },
    northeast: { lat: -42.867874, lng: 147.347964 },
  },
  'le_5f169380fd43eadac8a9f1423aaa9ac8': { // Canberra -> Canberra City Centre (le_629cd97c7d72a1d7e85909c24d66fe5f, r=1.2km)
    southwest: { lat: -35.290390, lng: 149.116735 },
    northeast: { lat: -35.269509, lng: 149.142313 },
  },
  'le_3f08f0e6992e8d712984a799e6681209': { // Darwin -> Darwin City Centre (le_0a7184747218c4cb31e983ab19d01dab, r=1.3km)
    southwest: { lat: -12.472624, lng: 130.830303 },
    northeast: { lat: -12.449536, lng: 130.853947 },
  },
  'le_66ff0e7c30438d414ff0a941b759f114': { // London -> London City Centre (le_8150c8232c40a27facde91222e859ead, r=7.7km)
    southwest: { lat: 51.434046, lng: -0.248810 },
    northeast: { lat: 51.573225, lng: -0.025217 },
  },
  'le_bd4c9ab730f5513206b999ec0d90d1fb': { // Singapore -> Singapore Central Business District (le_bf6a141b7ea02381cfade57101113e70, r=1.1km)
    southwest: { lat: 1.277877, lng: 103.846357 },
    northeast: { lat: 1.297881, lng: 103.866365 },
  },
  'le_bac732346917b0a1231354ef55faf00a': { // Gold Coast -> Surfers Paradise / Broadbeach strip (hand-tuned)
    southwest: { lat: -28.058795, lng: 153.390229 },
    northeast: { lat: -27.975524, lng: 153.439668 },
  },
}
